import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter018() {
  return <KbChapterPage slug="chapter-018" />;
}

(Chapter018 as unknown as { path: string }).path = "/theory-album/018";
